import { view, cssGenerator } from '@yola/ws-sdk';
import truncateToOneDecimal from './truncate-to-one-decimal';

const { MARGIN_TOP, MARGIN_BOTTOM, LINE_HEIGHT } = cssGenerator.constants.attributes;

const getLineHeight = (element, computedStyle) => {
  const lineHeight = element.getAttribute(LINE_HEIGHT);
  const fontSize = parseFloat(computedStyle.fontSize) || 1;

  const parseLineHeightFromPxToEm = (value) => {
    if (!value) return null;

    const numericValue = parseFloat(value);

    if (value.trim().endsWith('px')) {
      return numericValue / fontSize;
    }

    return numericValue;
  };

  if (lineHeight) {
    return parseFloat(view.helpers.getBreakpointValue(lineHeight, 'xl'));
  }

  const computedLineHeight = computedStyle.lineHeight;

  if (computedLineHeight === 'normal') {
    return 1;
  }

  const parsedComputedValue = parseLineHeightFromPxToEm(computedLineHeight);
  return parsedComputedValue !== null ? truncateToOneDecimal(parsedComputedValue) : 1;
};

const getMarginValue = (element, computedStyle, attribute, computedProperty) => {
  const attrValue = element.getAttribute(attribute);
  return attrValue ? parseFloat(attrValue) : parseFloat(computedStyle[computedProperty]) || 0;
};

const getElementSpacingValues = (element) => {
  if (!element) return null;

  const liveDocument = view.accessors.getLiveDocument();
  const computedStyle = liveDocument.defaultView.getComputedStyle(element);

  return {
    lineHeight: getLineHeight(element, computedStyle),
    marginTop: getMarginValue(element, computedStyle, MARGIN_TOP, 'marginTop'),
    marginBottom: getMarginValue(element, computedStyle, MARGIN_BOTTOM, 'marginBottom'),
  };
};

export default getElementSpacingValues;
